import React, { useState, useEffect } from "react";
import { useRouteMatch, Switch, Route } from "react-router-dom";

// import subsections
import PromosAll from "./PromosAll/PromosAll";
import PromosCreate from "./PromosCreate/PromosCreate";

import { posts } from "../../../staticData/posts";
import Hint from "../../utils/Hint/Hint";

const sortPromos = (a, b) => {
  let A = a.promopostDate;
  let B = b.promopostDate;

  if (A > B) {
    return -1;
  } else if (B > A) {
    return 1;
  } else {
    return 0;
  }
};

const PromosSection = ({
  staticWebsiteMenus,
  isAllMenusLoading,
  promos,
  handleCreatePromopost,
  handleTogglePromopostActive,
  handleUpdatePromopost,
  handleDeletePromopost,
  mediaURLs,
  setMediaURLs
}) => {
  let match = useRouteMatch();

  return (
    <section className="section promosSection">
      <h2 className="sectionHeading">Media posts</h2>
      <Hint
        hintHeading="Media posts"
        hintText={`
        <div>
        <div>
          The media posts manager is the core part of the content management system.
          </div>
          <div>
          It allows a non-technical user to prepare and release content-rich, SEO-friendly publications. It is tuned well with other parts of the system and allows referencing parts of the database in a consistent manner (like the menus database in this demo).
          </div>
          <div>
          The system supports a more advanced approach, as well. Admin users are free to create more complex materials themselves using raw HTML and CSS, or hire an external specialist to code the layout and simply paste it into the post's body field. 
          </div>
          <div>
          The full version supports publication-scaled media files uploads and expanded SEO tooling.
          </div>
          <div>
          The system can be adjusted to the requirements and the architecture of the customer-facing application.
          </div>
          </div>
        `}
        openOnMount={false}
        top="5em"
        right="3em"
      />
      <Switch>
        <Route path={`${match.path}/create_new`}>
          <PromosCreate
            handleCreatePromopost={handleCreatePromopost}
            menus={staticWebsiteMenus}
            isAllMenusLoading={isAllMenusLoading}
            mediaURLs={mediaURLs}
            setMediaURLs={setMediaURLs}
          />
        </Route>
        <Route path={match.path}>
          <PromosAll
            promos={promos && promos.sort(sortPromos)}
            handleCreatePromopost={handleCreatePromopost}
            handleTogglePromopostActive={handleTogglePromopostActive}
            handleUpdatePromopost={handleUpdatePromopost}
            handleDeletePromopost={handleDeletePromopost}
            menus={staticWebsiteMenus}
            isAllMenusLoading={isAllMenusLoading}
            mediaURLs={mediaURLs}
            setMediaURLs={setMediaURLs}
          />
        </Route>
      </Switch>
    </section>
  );
};

export default PromosSection;
